export const ENV_NAME = 'development';
export const DISABLE_ANALYTICS = true;
export const BASE_URL = 'http://localhost:3000/';
export const BASE_WS_URL = 'ws://localhost:3010';
export const CLOUD_PROVIDER = 'azure'; // aws | azure
export const S3_PUBLIC_BUCKET_URL =
  'https://outpatientstorageaccount.blob.core.windows.net/op-dev-public/';
export const TURNSTYLE_SITE_KEY = '0x4AAAAAAAGsihvHw0KcRK5d';
// export const TURNSTYLE_SITE_KEY = '1x00000000000000000000AA';
export const USE_OKTA = true;
export const OKTA_CLIENT_ID = '0oatd76gs728lyqMG697';
